import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { MediaClipboardService } from 'media/services/mediaClipboard.service'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class CopyOp extends BaseOperation {
  icon = 'far fa-copy'
  showInSelectionToolbar = true
  showInContextMenu = true
  showInAssetView = true
  supportsMultiple = true
  supportsDirs = true
  supportsBundles = true
  weight = -10

  constructor (
    private translate: TranslateService,
    private mediaClipboard: MediaClipboardService,
    private mediaPermissions: MediaPermissionsService,
  ) {
    super()
    this.label = translate.instant('Copy')
  }

  isVisibleFor () {
    return this.mediaPermissions.permissions.some(x => x.allowWriteFs)
  }

  isEnabledForDir (dir) {
    return dir.present
  }

  isEnabledForBundle (bundle) {
    return bundle.mainfile?.present
  }

  async run ({ dirs, bundles }) {
    this.mediaClipboard.copyFiles(dirs, 'copy')
    this.mediaClipboard.copyBundles(bundles, 'copy')
  }
}

MediaOperationsService.register(CopyOp)
